import TextImage from './TextImage';

export default TextImage;
